export enum EnumModeResetPassword {
    Mail = 'Mail',
    Sms = 'Sms',
    None = 'None',
}
